/**
 * @generated SignedSource<<effc0a54d057397beaff433063feba6e>>
 * @relayHash 98f612a3f655fc8405c8c2f08d3284ee
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 98f612a3f655fc8405c8c2f08d3284ee

import { ConcreteRequest } from 'relay-runtime';
export type useChDeleteTimeWindowMutation$variables = {
  id: string;
};
export type useChDeleteTimeWindowMutation$data = {
  readonly ch_deleteTimeWindow: {
    readonly ch_TimeWindow: {
      readonly id: string;
    } | null;
  };
};
export type useChDeleteTimeWindowMutation = {
  response: useChDeleteTimeWindowMutation$data;
  variables: useChDeleteTimeWindowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Ch_deleteTimeWindowPayload",
    "kind": "LinkedField",
    "name": "ch_deleteTimeWindow",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ch_TimeWindow",
        "kind": "LinkedField",
        "name": "ch_TimeWindow",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeleteTimeWindowMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeleteTimeWindowMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "98f612a3f655fc8405c8c2f08d3284ee",
    "metadata": {},
    "name": "useChDeleteTimeWindowMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c8202d4ccdf3ae1ccd734c458bdca795";

export default node;
